// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function marida(): string {
    return 'marida';
}
